import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as fb_sign_out,
} from 'firebase/auth';
import { api, ApiError } from './api';

const firebase_config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

const fb_app = initializeApp(firebase_config);
export const fb_auth = getAuth(fb_app);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ hd: 'captomi.com', prompt: 'select_account' });

export interface AdminProfile {
  email: string;
  full_name: string;
  picture_url: string;
  role: string;
}

export async function sign_in_with_google(): Promise<AdminProfile> {
  const result = await signInWithPopup(fb_auth, provider);
  const id_token = await result.user.getIdToken();
  try {
    return await api.post<AdminProfile>('/api/session', { id_token });
  } catch (err) {
    await fb_sign_out(fb_auth);
    throw err;
  }
}

export async function sign_out(): Promise<void> {
  try {
    await api.post('/api/logout', {});
  } catch {
    /* clear client state regardless of server response */
  }
  await fb_sign_out(fb_auth);
}

export async function get_current_admin(): Promise<AdminProfile | null> {
  try {
    return await api.get<AdminProfile>('/api/me');
  } catch (err) {
    if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
      return null;
    }
    throw err;
  }
}
